import { Box3, Camera, Vector3 } from 'three'

export type ProjectedBounds={left:number;right:number;bottom:number;top:number;near:number;far:number}
export function projectCityBounds(bounds:Box3,camera:Camera):ProjectedBounds {
  const result={left:Infinity,right:-Infinity,bottom:Infinity,top:-Infinity,near:Infinity,far:-Infinity}
  const p=new Vector3()
  for(const x of [bounds.min.x,bounds.max.x])for(const y of [bounds.min.y,bounds.max.y])for(const z of [bounds.min.z,bounds.max.z]){
    p.set(x,y,z).applyMatrix4(camera.matrixWorldInverse)
    result.near=Math.min(result.near,-p.z);result.far=Math.max(result.far,-p.z)
    p.applyMatrix4(camera.projectionMatrix)
    result.left=Math.min(result.left,p.x);result.right=Math.max(result.right,p.x)
    result.bottom=Math.min(result.bottom,p.y);result.top=Math.max(result.top,p.y)
  }
  return result
}

// Clear the selected property's full silhouette, not just its center. Use camera
// space so the obstruction test follows orbit and zoom, including narrow screens.
export function blocksCityProperty(target:ProjectedBounds,building:ProjectedBounds):boolean {
  const margin=.025
  return building.near<target.far-.1&&building.far>0&&
    building.right>target.left-margin&&building.left<target.right+margin&&
    building.top>target.bottom-margin&&building.bottom<target.top+margin
}
